export const Unite = {
  DOTCOM_UX_ID: 'com.nike.commerce.nikedotcom.web',
};
